import { render, staticRenderFns } from "./SearchHit.vue?vue&type=template&id=04be5c4c"
import script from "./SearchHit.vue?vue&type=script&lang=js"
export * from "./SearchHit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports